/* Sunnah shop - geurtest (6 vragen) */
(function () {
  'use strict';
  if (window.SunnahQuiz) { window.SunnahQuiz.init(document); return; }
  var FAM = {
    zoet: { l: 'Zoet', e: '🍯', c: '#8a4b1c', b: '#f6e7d8', k: ['gourmand', 'zoet', 'vanille', 'vanilla', 'karamel', 'caramel', 'pralin', 'tonka', 'honing', 'chocolade', 'cacao', 'kokos', 'suiker', 'candy'] },
    orient: { l: 'Oriëntaals', e: '🌙', c: '#7a5a0b', b: '#f5ecd2', k: ['oriënt', 'orient', 'amber', 'wierook', 'oud', 'saffraan', 'musk', 'muskus'] },
    hout: { l: 'Houtachtig', e: '🌲', c: '#4d6230', b: '#e6ecdc', k: ['hout', 'woody', 'ceder', 'sandel', 'vetiver', 'patchoeli', 'eiken'] },
    fris: { l: 'Fris', e: '🍋', c: '#1f6a8a', b: '#dcedf3', k: ['fris', 'fresh', 'citrus', 'bergamot', 'citroen', 'grapefruit', 'mandarijn', 'munt', 'aquat', 'marine', 'zeebries', 'ozon', 'aromatisch'] },
    bloem: { l: 'Bloemig', e: '🌸', c: '#a8336b', b: '#f8dfe8', k: ['bloem', 'floral', 'roos', 'rozen', 'jasmijn', 'iris', 'lelie', 'pioen', 'tuberoos', 'ylang', 'oranjebloesem', 'magnolia'] },
    kruid: { l: 'Kruidig', e: '🌶️', c: '#a3401c', b: '#f6e0d4', k: ['kruid', 'spicy', 'peper', 'kaneel', 'kardemom', 'gember', 'nootmuskaat', 'kruidnagel'] },
    fruit: { l: 'Fruitig', e: '🍓', c: '#6e3fa3', b: '#ece1f5', k: ['fruit', 'framboos', 'aardbei', 'perzik', 'appel', 'peer', 'ananas', 'kersen', 'bessen', 'mango', 'lychee', 'cassis', 'pruim'] }
  };
  var ORDER = ['zoet', 'orient', 'hout', 'fris', 'bloem', 'kruid', 'fruit'];
  var BY_LABEL = { gourmand: 'zoet', orientaals: 'orient', houtig: 'hout' };
  ORDER.forEach(function (f) { BY_LABEL[FAM[f].l.toLowerCase()] = f; });
  var RE = {};
  ORDER.forEach(function (f) { RE[f] = FAM[f].k.map(function (k) { return new RegExp('(^|[^a-z\\u00e0-\\u00ff])' + k, 'g'); }); });
  var Q = [
    { q: 'Voor wie zoek je een geur? 🎁', a: [
      { e: '👩', t: 'Voor haar', g: 'haar' }, { e: '👨', t: 'Voor hem', g: 'hem' }, { e: '✨', t: 'Maakt niet uit', g: 'alle' } ] },
    { q: 'Welke geur maakt jou blij? 😍', a: [
      { e: '🧁', t: 'Vers gebakken taart en vanille', s: { zoet: 3 } },
      { e: '🌊', t: 'Een frisse zeebries', s: { fris: 3 } },
      { e: '💐', t: 'Een boeket verse bloemen', s: { bloem: 3 } },
      { e: '🌲', t: 'Een bos na een regenbui', s: { hout: 3 } },
      { e: '🍓', t: 'Een schaal vers fruit', s: { fruit: 3 } } ] },
    { q: 'Wanneer draag je je parfum het vaakst? 🕐', a: [
      { e: '☀️', t: 'Overdag, naar werk of school', s: { fris: 1, bloem: 1, fruit: 1 } },
      { e: '🌙', t: 'In de avond en bij het uitgaan', s: { orient: 2, zoet: 1, kruid: 1 } },
      { e: '🥂', t: 'Op speciale momenten', s: { orient: 1, hout: 1, bloem: 1 } },
      { e: '🔁', t: 'Elke dag, altijd', s: {} } ] },
    { q: 'In welk seizoen draag je hem vooral? 🍂', a: [
      { e: '🌸', t: 'Lente en zomer', s: { fris: 2, fruit: 1, bloem: 1 } },
      { e: '❄️', t: 'Herfst en winter', s: { zoet: 1, orient: 1, kruid: 1, hout: 1 } },
      { e: '📅', t: 'Het hele jaar door', s: {} } ] },
    { q: 'Hoe sterk mag je geur zijn? 💪', a: [
      { e: '🤏', t: 'Zacht en dichtbij', s: { fris: 1, bloem: 1 } },
      { e: '👌', t: 'Merkbaar, maar niet te veel', s: { fruit: 1, hout: 1 } },
      { e: '📣', t: 'Iedereen mag het ruiken', s: { orient: 2, kruid: 1, zoet: 1 } } ] },
    { q: 'Welke sfeer past het best bij jou? ✨', a: [
      { e: '🎩', t: 'Elegant en klassiek', s: { bloem: 1, hout: 1, orient: 1 } },
      { e: '🔥', t: 'Warm en verleidelijk', s: { orient: 2, zoet: 1 } },
      { e: '⚡', t: 'Sportief en fris', s: { fris: 2 } },
      { e: '🎉', t: 'Speels en vrolijk', s: { fruit: 2, zoet: 1 } } ] }
  ];
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CART_ADD = (window.routes && window.routes.cart_add_url) || (ROOT + 'cart/add');
  var CURRENCY = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function textOf(html) {
    if (!html) return '';
    try { return new DOMParser().parseFromString(html, 'text/html').body.textContent || ''; } catch (e) { return ''; }
  }
  function money(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    try { return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: CURRENCY }).format(n); } catch (e) { return n.toFixed(2); }
  }
  function chip(f) {
    var x = FAM[f];
    return '<span class="sn-chip" style="--bg:' + x.b + ';--c:' + x.c + '"><span aria-hidden="true">' + x.e + '</span>' + esc(x.l) + '</span>';
  }
  function profile(p) {
    if (p.__snProf) return p.__snProf;
    var prof = {};
    var tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',');
    tags.forEach(function (t) {
      var m = String(t).toLowerCase().match(/^\s*geur(-2)?\s*:\s*(.+)$/);
      if (m) { var key = BY_LABEL[m[2].trim()]; if (key) { prof[key] = (prof[key] || 0) + (m[1] ? 2 : 4); } }
    });
    var text = ((p.title || '') + ' ' + textOf(p.body_html)).toLowerCase();
    var ci = text.indexOf('categorie');
    var head = ci > -1 ? text.slice(ci, ci + 110) : text.slice(0, 240);
    ORDER.forEach(function (f) {
      var hits = 0, inHead = false;
      RE[f].forEach(function (re) {
        var m = text.match(re); if (m) { hits += m.length; }
        re.lastIndex = 0;
        if (re.test(head)) { inHead = true; }
        re.lastIndex = 0;
      });
      if (hits) { prof[f] = (prof[f] || 0) + Math.min(hits, 4) * 0.5; }
      if (inHead) { prof[f] = (prof[f] || 0) + 2; }
    });
    p.__snProf = prof;
    return prof;
  }
  function topFams(prof, n) {
    return ORDER.filter(function (f) { return prof[f] > 0; }).sort(function (a, b) { return prof[b] - prof[a]; }).slice(0, n || 2);
  }
  function score(p, user) {
    var prof = profile(p), s = 0, tot = 0, f;
    for (f in prof) { tot += prof[f]; }
    for (f in user) { s += user[f] * (prof[f] || 0); }
    return s / Math.sqrt(1 + tot);
  }
  function available(p) { return (p.variants || []).some(function (v) { return v.available; }); }
  function variantOf(p) {
    var vs = p.variants || [];
    for (var i = 0; i < vs.length; i++) { if (vs[i].available) return vs[i]; }
    return vs[0];
  }
  function card(p, top) {
    var v = variantOf(p), fams = topFams(profile(p), 2);
    var bg = fams.length ? FAM[fams[0]].b : '#f7f1e3';
    var url = ROOT + 'products/' + encodeURIComponent(p.handle);
    var img = p.images && p.images[0] ? p.images[0].src : '';
    if (img) { img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=' + (top ? 560 : 320); }
    return '<article class="sn-qr' + (top ? ' sn-qr--top' : '') + '">' +
      (img ? '<a class="sn-qr__img" style="background:' + bg + '" href="' + url + '" tabindex="-1" aria-hidden="true"><img src="' + esc(img) + '" alt="" loading="lazy" width="560" height="700"></a>' : '<span></span>') +
      '<div>' + (top ? '<span class="sn-qr__badge">🏆 Jouw beste match</span>' : '') +
      '<h4 class="sn-qr__title"><a href="' + url + '">' + esc(p.title) + '</a></h4>' +
      '<div style="display:flex;flex-wrap:wrap;gap:.6rem">' + fams.map(chip).join('') + '</div>' +
      (v ? '<p class="sn-qr__price">' + money(v.price) + '</p>' : '') +
      '<div class="sn-qr__actions">' +
      (v ? '<form method="post" action="' + esc(CART_ADD) + '"><input type="hidden" name="id" value="' + esc(v.id) + '"><input type="hidden" name="quantity" value="1"><button type="submit" class="sn-btn sn-btn--gold">In winkelmand</button></form>' : '') +
      '<a class="sn-link" href="' + url + '">Bekijk geur</a></div></div></article>';
  }
  function confetti(root) {
    var box = root.querySelector('[data-sn-confetti]');
    if (!box || REDUCED) return;
    var cols = ['#c9a24a', '#f8dfe8', '#dcedf3', '#e6ecdc', '#f6e7d8', '#ece1f5', '#ffffff'];
    var html = '';
    for (var i = 0; i < 40; i++) {
      html += '<i style="left:' + (Math.random() * 100).toFixed(1) + '%;background:' + cols[i % cols.length] +
        ';--x:' + ((Math.random() - 0.5) * 18).toFixed(1) + 'rem;--r:' + Math.round(Math.random() * 720 - 360) +
        'deg;animation-delay:' + (Math.random() * 0.5).toFixed(2) + 's"></i>';
    }
    box.innerHTML = html;
    setTimeout(function () { box.innerHTML = ''; }, 3600);
  }
  function load(url) {
    if (!url) return Promise.resolve([]);
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (d) { return (d && d.products) || []; });
  }
  function Quiz(root) {
    var self = this;
    this.root = root; this.step = 0; this.answers = []; this.busy = false; this.data = null; this.loading = null;
    this.screens = { start: root.querySelector('[data-step="start"]'), q: root.querySelector('[data-step="q"]'), result: root.querySelector('[data-step="result"]') };
    this.qEl = root.querySelector('[data-sn-q]');
    this.ansEl = root.querySelector('[data-sn-answers]');
    this.countEl = root.querySelector('[data-sn-count]');
    this.barEl = root.querySelector('[data-sn-bar]');
    this.backEl = root.querySelector('[data-sn-back]');
    root.querySelector('[data-sn-start]').addEventListener('click', function () { self.start(); });
    root.querySelector('[data-sn-restart]').addEventListener('click', function () { self.start(); });
    this.backEl.addEventListener('click', function () { self.back(); });
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { self.prefetch(); obs.disconnect(); } }, { rootMargin: '400px' });
      obs.observe(root);
    } else { this.prefetch(); }
  }
  Quiz.prototype.prefetch = function () {
    var self = this;
    if (this.data) return Promise.resolve(this.data);
    if (this.loading) return this.loading;
    this.loading = Promise.all([load(this.root.getAttribute('data-haar')), load(this.root.getAttribute('data-hem'))])
      .then(function (res) {
        var list = [], seen = {}, haar = {}, hem = {};
        res[0].forEach(function (p) { haar[p.id] = true; if (!seen[p.id]) { seen[p.id] = true; list.push(p); } });
        res[1].forEach(function (p) { hem[p.id] = true; if (!seen[p.id]) { seen[p.id] = true; list.push(p); } });
        self.data = { list: list, haar: haar, hem: hem };
        return self.data;
      })
      .catch(function () { self.loading = null; return { list: [], haar: {}, hem: {} }; });
    return this.loading;
  };
  Quiz.prototype.show = function (name) {
    for (var k in this.screens) {
      var s = this.screens[k], on = (k === name);
      s.hidden = !on;
      s.classList.remove('is-active');
      if (on) { void s.offsetWidth; s.classList.add('is-active'); }
    }
  };
  Quiz.prototype.start = function () { this.step = 0; this.answers = []; this.busy = false; this.prefetch(); this.render(); };
  Quiz.prototype.render = function () {
    var self = this, item = Q[this.step];
    this.countEl.textContent = 'Vraag ' + (this.step + 1) + ' van ' + Q.length;
    this.barEl.style.width = (this.step / Q.length * 100) + '%';
    this.qEl.textContent = item.q;
    this.ansEl.innerHTML = '';
    item.a.forEach(function (a, idx) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sn-quiz__answer' + (self.answers[self.step] === idx ? ' is-picked' : '');
      b.innerHTML = '<span class="sn-e" aria-hidden="true">' + a.e + '</span><span>' + esc(a.t) + '</span>';
      b.addEventListener('click', function () { self.pick(idx, b); });
      self.ansEl.appendChild(b);
    });
    this.backEl.hidden = this.step === 0;
    this.show('q');
    try { this.qEl.focus({ preventScroll: true }); } catch (e) {}
  };
  Quiz.prototype.pick = function (idx, btn) {
    var self = this;
    if (this.busy) return;
    this.busy = true;
    this.answers[this.step] = idx;
    Array.prototype.forEach.call(this.ansEl.children, function (c) { c.classList.toggle('is-picked', c === btn); });
    setTimeout(function () {
      self.busy = false;
      if (self.step < Q.length - 1) { self.step++; self.render(); } else { self.finish(); }
    }, 280);
  };
  Quiz.prototype.back = function () { if (this.step > 0) { this.step--; this.render(); } };
  Quiz.prototype.finish = function () {
    var self = this;
    var out = this.root.querySelector('[data-sn-results]');
    var prof = this.root.querySelector('[data-sn-profile]');
    var title = this.root.querySelector('[data-sn-result-title]');
    var user = {}, gender = 'alle';
    this.answers.forEach(function (ai, qi) {
      var a = Q[qi] && Q[qi].a[ai];
      if (!a) return;
      if (a.g) { gender = a.g; }
      if (a.s) { for (var f in a.s) { user[f] = (user[f] || 0) + a.s[f]; } }
    });
    prof.innerHTML = topFams(user, 2).map(chip).join('');
    out.innerHTML = '<div class="sn-quiz__loading"><span class="sn-spin" aria-hidden="true"></span>Even zoeken naar jouw geur...</div>';
    this.barEl.style.width = '100%';
    this.show('result');
    this.prefetch().then(function (data) {
      var ranked = [];
      data.list.forEach(function (p) {
        if (gender === 'haar' && !data.haar[p.id]) return;
        if (gender === 'hem' && !data.hem[p.id]) return;
        if (!available(p)) return;
        var s = score(p, user);
        if (gender === 'alle' && data.haar[p.id] && data.hem[p.id]) { s *= 1.1; }
        ranked.push({ p: p, s: s });
      });
      ranked.sort(function (a, b) { return b.s - a.s; });
      var picks = ranked.slice(0, 3);
      if (!picks.length) {
        out.innerHTML = '<p class="sn-sub" style="margin:0">We konden de geuren nu even niet laden. <a class="sn-link" href="' + ROOT + 'collections/all">Bekijk alle parfums</a></p>';
        return;
      }
      out.innerHTML = picks.map(function (x, i) { return card(x.p, i === 0); }).join('');
      confetti(self.root);
      try { title.focus({ preventScroll: true }); } catch (e) {}
    });
  };
  function init(root) {
    (root || document).querySelectorAll('[data-sn-quiz]').forEach(function (el) {
      if (el.__snq) return; el.__snq = true;
      new Quiz(el);
    });
  }
  window.SunnahQuiz = { init: init };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { init(document); }); } else { init(document); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();